import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import orologo from "../Image/oro-logo.jpeg";
import mpcst from "../Image/newmpcst-logo.jpg";

import Adminsidebar from './Adminsidebar';
import DesktopFooter from "../Component/Desktopfooter";

import axios from 'axios';

import { Link, useParams } from 'react-router-dom';

const Admintable = () => {

  const [rows, setRows] = useState([]);

  // URL se type ayega
  const { type } = useParams();

 useEffect(() => {
  fetchUsers();
}, [type]);
  const fetchUsers = async () => {

    try {

      // public/private ke hisab se API hit
      const res = await axios.get(`/api/getusers?type=${type}`);

      setRows(res.data);

    } catch (err) {

      console.error('Error fetching users:', err);

    }

  };

  return (
    <>
      <div className="app-header-wrapper">

        <div className="header-logo">
          <img src={orologo} alt="logo" />
        </div>

        <div className="header-text">

          <Typography
            variant="h4"
            sx={{ textTransform: "uppercase" }}
          >
            Orocancer Watch
          </Typography>

          <Typography
            variant="body1"
            sx={{ textTransform: "uppercase" }}
          >
            All India Institute of Medical Sciences, Bhopal
          </Typography>

        </div>

        <div className="header-logo">
          <img src={mpcst} alt="logo" />
        </div>

      </div>

      <div className='admin-dashoardpanel'>

        <Adminsidebar />

        <div className='customdatatable-wrapper'>

          <div className='dashboard-header'>

            <Typography variant='h2'>

              {type === "public"
                ? "Public Users"
                : "Private Users"}

            </Typography>

          </div>

          <div className='tiles-filter-wrapper'>

            <Link className='download' to="#">
              Download all
            </Link>

            <TableContainer component={Paper}>

              <Table>

                <TableHead>

                  <TableRow>
                    <TableCell>S.No</TableCell>
                    <TableCell>Phone No.</TableCell>
                    <TableCell>Total Attempts</TableCell>
                    <TableCell>Latest Attempt</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>

                </TableHead>

                <TableBody>

                  {rows.length > 0 ? (

                    rows.map((row, index) => (

                      <TableRow key={row.id}>

                        <TableCell>{index + 1}</TableCell>

                        <TableCell>
                          {row.user_number}
                        </TableCell>

                        <TableCell>
                          {row.attempt_no}
                        </TableCell>

                        <TableCell>
                          {row.last_attempt}
                        </TableCell>

                        <TableCell>

                          <Button
                            variant="contained"
                            size="small"
                            component={Link}
                            to={`/user/${row.id}`}
                          >
                            View
                          </Button>

                        </TableCell>

                      </TableRow>

                    ))

                  ) : (

                    <TableRow>

                      <TableCell
                        colSpan={5}
                        align="center"
                      >
                        No Data Found
                      </TableCell>

                    </TableRow>

                  )}

                </TableBody>

              </Table>

            </TableContainer>

          </div>

        </div>

      </div>

      <DesktopFooter />

    </>
  );
};

export default Admintable;